<template>
     <div id="course" class="app-inner">
           <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addCourse">
        新增课程
      </div>
    </div>
    <div class="p-tit-c">
        <div class="businessList-filter">
             <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">课程名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入课程名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">课程ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入课程ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
          <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">课程分类：</div>
                     <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">费用信息：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(1)"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="1" >免费课</el-radio>
        <el-radio v-model="radio1" label="2">付费课</el-radio>
      </div>
        </div>
    </div>
     </div>
</template>
<script>
import {getAllCourseClassify} from "@/api/index/index"  //应用分类
export default {
    name:'Course',
    data () {
        return {
            search:'',
            search1:'',
            itemList:[],
            value:'',
        }
    },
    created () {
        this.getCourseClass()
    },
    methods: {
        // 筛选
        allradio(type){
            
        },
        // 获取分类
        getCourseClass(){
            this.itemList = []
             getAllCourseClassify({
                name:''
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
        // 打开新增课程窗口
        addCourse(){

        },
    },
}
</script>
<style lang="scss" scoped>
#course{
         .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
}
</style>